import * as React from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";

const columns = [
  { id: "number", label: "#", minWidth: 80 },
  { id: "serialNumber", label: "الرقم", minWidth: 170 },
  { id: "status", label: "الحالة", minWidth: 60 },
  { id: "dateAdded", label: "الدخول", minWidth: 60 },
  { id: "dateRemoved", label: "الخروج", minWidth: 60 },
  { id: "date", label: "الانتاج", minWidth: 60 },
  {
    id: "boxWeight",
    label: "وزن الكرتون",
    minWidth: 60,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "bagWeight",
    label: "وزن الكيس",
    minWidth: 60,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "numOfBags",
    label: "عدد الأكياس",
    minWidth: 60,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "datesType",
    label: "نوع التمر",
    minWidth: 60,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "datesGrade",
    label: "نجمة",
    minWidth: 60,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "extraLabel",
    label: "رمز",
    minWidth: 60,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "datesWash",
    label: "غسلة",
    minWidth: 60,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
];

function createData(
  number,
  serialNumber,
  status,
  dateAdded,
  dateRemoved,
  date,
  boxWeight,
  bagWeight,
  numOfBags,
  datesType,
  datesGrade,
  extraLabel,
  datesWash
) {

  status = status? "في المخزن" : "خارج المخزن";
  dateRemoved = dateRemoved? dateRemoved : "-";
  return {
    number,
    serialNumber,
    status,
    dateAdded,
    dateRemoved,
    date,
    boxWeight,
    bagWeight,
    numOfBags,
    datesType,
    datesGrade,
    extraLabel,
    datesWash,
  };
}

/* var num = 1;
const rows = [
  createData(num++, 1000001, 2206, 20, 1, 20),
  createData(num++, 1000002, 2006, 0.5, 0.5, 1),
]; */

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

function StatsTable({ stats }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  var num = 1;
  let rows = [];
  console.log("boxes data: ");
  stats.boxes.forEach((element) => {
    /*console.log(
      `${num}, ${element.serialNumber}, ${element.date}, ${element.boxWeight}, 
      ${element.bagWeight}, ${element.numOfBags}, 
      ${element.datesType}, ${element.datesGrade}, ${element.datesWash}`
    );*/
    rows.push(
      createData(
        num++,
        element.serialNumber,
        element.inStock,
        element.dateAdded,
        element.dateRemoved,
        element.date,
        element.boxWeight,
        element.bagWeight,
        element.numOfBags,
        element.datesType,
        element.datesGrade,
        element.extraLabel || ".",
        element.datesWash
      )
    );
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <StyledTableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === "number"
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}

export default StatsTable;
